import {PageLink} from '../../_metronic/layout/core'
import {Navigation} from '../../components/Navigation'
import ProductReport from './layouts/ProductReport'

const PurchasingNoSoldProductPageBreadCrumbs: Array<PageLink> = [
  {
    title: 'Purchasing',
    path: '/purchasing/no-sold-product',
    isSeparator: false,
    isActive: true,
  },
]

function PurchasingNoSoldProductPage() {
  return (
    <Navigation
      baseUrl='/purchasing/no-sold-product'
      breadcrumbs={PurchasingNoSoldProductPageBreadCrumbs}
      pageTitle='No Sold Product Report'
      navigationData={[
        {
          key: 'product-report',
          label: 'Product',
          component: <ProductReport />,
        },
      ]}
    />
  )
}

export default PurchasingNoSoldProductPage
